import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const sections = [
  
    {
      title: 'Subscribe & Contribute',
      links: [
        { text: 'Subscribe to Directory', href: '/register' },
        { text: 'How to Use Directory', href: '/how-to-use' },
        { text: 'Get Featured', href: 'https://rzp.io/rzp/o7ka3Z5' },
        { text: 'Buy Print Copy', href: 'https://rzp.io/rzp/6eZ5Rcp' }
      ]
    }
  ];

  return (
    <footer className="bg-gray-800/90 border-t border-gray-700 backdrop-blur-sm mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Main footer content */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-8">
          {/* Feature sections */}
          {sections.map((section, index) => (
            <div key={index} className="space-y-4">
              <h3 className="text-yellow-500 font-semibold text-lg">{section.title}</h3>
              <ul className="space-y-2">
                {section.links.map((link, linkIndex) => (
                  <li key={linkIndex}>
                    <Link
                      to={link.href}
                      className="text-gray-400 hover:text-yellow-500 transition-colors duration-200 text-sm flex items-center"
                    >
                      <svg className="h-4 w-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                      </svg>
                      {link.text}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          {/* Contact section */}
          <div className="space-y-4">
            <h3 className="text-yellow-500 font-semibold text-lg">Contact Us</h3>
            <p className="text-gray-400 text-sm">
              For any queries regarding the directory, subscriptions, or listings, please reach out to us.
            </p>
            <div className="flex items-center text-gray-400">
              <svg className="h-5 w-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
              <span className="text-sm">directory@defencepartners.in</span>
            </div>
          </div>
        </div>

        {/* Legal links */}
        <div className="border-t border-gray-700 pt-8">
          <div className="flex flex-wrap justify-center gap-4 text-xs text-gray-400">
            <Link to="/terms" className="hover:text-yellow-500 transition-colors duration-200">Terms of Use</Link>
            <Link to="/privacy" className="hover:text-yellow-500 transition-colors duration-200">Privacy Policy</Link>
            <Link to="/cancellation" className="hover:text-yellow-500 transition-colors duration-200">Cancellation and Refunds</Link>
            <Link to="/shipping" className="hover:text-yellow-500 transition-colors duration-200">Shipping & Delivery</Link>
            <Link to="/copyright" className="hover:text-yellow-500 transition-colors duration-200">Copyright Notice</Link>
          </div>
          <div className="text-center mt-4 text-xs text-gray-500">
            © 2024–2025 IMR Media Pvt Ltd. All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
